"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListBox = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_dom_1 = __importDefault(require("react-dom"));
var _1 = require("../util/_");
var classnames_1 = require("../util/classnames");
var dom_helpers_1 = require("../util/dom-helpers");
var custom_prop_types_1 = __importDefault(require("../util/custom-prop-types"));
var list_1 = require("../list");
var list_groupable_1 = require("../list/list-groupable");
var list_box_option_1 = require("./list-box-option");
var popup_1 = require("../popup");
var scroll_to_1 = require("../util/dom-helpers/util/scroll-to");
var data_helpers_1 = require("../util/data-helpers");
var widget_helpers_1 = require("../util/widget-helpers");
var interaction_1 = require("../util/interaction");
var vdl_prefix_1 = require("../util/vdl-prefix");
var search_1 = __importDefault(require("adp-react-icons/lib/fa/search"));
var angle_down_1 = __importDefault(require("adp-react-icons/lib/fa/angle-down"));
var timeout_manager_1 = require("../util/timeout-manager");
var filter_1 = __importDefault(require("../util/filter"));
var focus_mixin_1 = require("../mixins/focus-mixin");
var localizers_1 = require("../util/localizers");
var dflt = function dflt(f) {
  return f === true ? 'startsWith' : f ? f : 'eq';
};
function getFirstValue(props) {
  var data = props.data,
    valueField = props.valueField;
  var value = _1.splat(this.props.value);
  if (value.length) {
    return _1.find(data, function (d) {
      return data_helpers_1.dataIndexOf(value, d, valueField) !== -1;
    }) || null;
  }
  return null;
}
function localizedMessage(messageKey, locale) {
  return localizers_1.message.formatMessage('adp-react-components/dropdown-list/' + messageKey, undefined, locale);
}
function msgs(msgs, locale) {
  return __assign({
    open: localizedMessage('OPEN', locale),
    filterPlaceholder: localizedMessage('FILTER_PLACEHOLDER', locale),
    emptyList: localizedMessage('EMPTY_LIST', locale),
    emptyFilter: localizedMessage('EMPTY_FILTER', locale)
  }, msgs);
}
function getFilter(matcher, searchTerm, ctx) {
  searchTerm = !ctx.props.caseSensitive ? searchTerm.toLowerCase() : searchTerm;
  return function (item) {
    var val = data_helpers_1.dataText(item, ctx.props.textField);
    if (!ctx.props.caseSensitive) {
      val = val.toLowerCase();
    }
    return matcher(val, searchTerm);
  };
}
var ListBox = /** @class */function (_super) {
  __extends(ListBox, _super);
  function ListBox(props) {
    var _this = _super.call(this, props) || this;
    _this._searchTerm = '';
    _this._isMounted = false;
    _this._timeoutManager = new timeout_manager_1.TimeoutManager();
    _this.setTimeout = function (key, callback, duration) {
      if (_this._isMounted) {
        return _this._timeoutManager.setTimeout(key, callback, duration);
      }
    };
    _this.clearTimeout = function (key) {
      return _this._timeoutManager.clearTimeout(key);
    };
    _this.handleBlur = function (event) {
      focus_mixin_1.handleBlur(_this, event, function (focused) {
        if (focused !== _this.state.focused) {
          if (!focused) {
            _this.close();
          }
        }
      });
    };
    _this.handleFocus = function (event) {
      focus_mixin_1.handleFocus(_this, event, function (focused) {
        // to avoid flicker went clicking an item and gaining focus at the same time.
        if (focused !== _this.state.focused) {
          if (focused) {
            _this.setState({
              focusedItem: getFirstValue(_this.props)
            });
          } else {
            _this.setState({
              focusedItem: null
            });
          }
        }
      });
    };
    _this.handleAriaActiveDescendant = function (id) {
      if (id === _this.state.ariaActiveDescendant) {
        return;
      }
      _this.setState({
        ariaActiveDescendant: id
      });
    };
    _this.filterIndexOf = function (items, searchTerm) {
      var idx = -1;
      var matches = typeof _this.props.filter === 'function' ? _this.props.filter : getFilter(filter_1.default[dflt(_this.props.filter)], searchTerm, _this);
      if (!searchTerm || !searchTerm.trim() || _this.props.filter && searchTerm.length < (_this.props.minLength || 1)) {
        return -1;
      }
      items.every(function (item, i) {
        if (matches(item, searchTerm, i)) {
          idx = i;
          return false;
        }
        return true;
      });
      return idx;
    };
    _this.filter = function (items, searchTerm) {
      var filter = _this.props.filter;
      var matches = typeof filter === 'string' ? getFilter(filter_1.default[filter], searchTerm, _this) : filter;
      if (!matches || !searchTerm || !searchTerm.trim() || searchTerm.length < (_this.props.minLength || 1)) {
        return items;
      }
      return items.filter(function (item, idx) {
        return matches(item, searchTerm, idx);
      });
    };
    _this._renderFilter = function (messages) {
      var disabled = _this.props.disabled;
      return react_1.default.createElement("div", {
        ref: function ref(c) {
          _this._filterWrapper = c;
        },
        className: vdl_prefix_1.vdlPrefix('dropdown-list__filter'),
        onClick: _this.focus
      }, react_1.default.createElement("input", {
        ref: function ref(b) {
          _this._filter = b;
        },
        className: vdl_prefix_1.vdlPrefix('dropdown-list__filter__input'),
        autoComplete: "off",
        placeholder: _1.result(messages.filterPlaceholder, _this.props),
        value: _this.state.searchTerm,
        onChange: function onChange(e) {
          return _this.updateSearchTerm(e.target.value);
        },
        disabled: disabled
      }), react_1.default.createElement("span", {
        className: vdl_prefix_1.vdlPrefix('dropdown-list__filter__search')
      }, react_1.default.createElement(search_1.default, null)));
    };
    _this._scrollTo = function (selected, list) {
      var handler = _this.props.onMove;
      if (handler) {
        handler(selected, list, undefined);
      } else {
        _this._scrollCancel && _this._scrollCancel();
        // default behavior is to scroll the whole page not just the widget
        if (!_this.props.multiple) {
          _this._scrollCancel = scroll_to_1.scrollTo(selected, undefined);
        }
      }
    };
    //FIXME @widgetEditable
    _this._keyDown = function (e) {
      var key = e.key;
      var _a = _this.props,
        valueField = _a.valueField,
        multiple = _a.multiple,
        filter = _a.filter;
      var list = _this._list;
      var focusedItem = _this.state.focusedItem;
      var change = function change(item) {
        if (item) {
          _this._change(item, multiple ? !interaction_1.contains(item, _this._values(), valueField) // toggle value
          : true);
        }
      };
      widget_helpers_1.notify(_this.props.onKeyDown, [e]);
      if (e.defaultPrevented) {
        return;
      }
      if (key === 'End') {
        e.preventDefault();
        focusedItem = list.last();
        _this.setState({
          focusedItem: focusedItem
        });
        if (!multiple) {
          change(focusedItem);
        }
      } else if (key === 'Home') {
        e.preventDefault();
        focusedItem = list.first();
        _this.setState({
          focusedItem: focusedItem
        });
        if (!multiple) {
          change(focusedItem);
        }
      } else if (key === 'Enter' || key === ' ' && !filter) {
        e.preventDefault();
        change(focusedItem);
      } else if (key === 'ArrowDown' || key === 'ArrowRight') {
        e.preventDefault();
        focusedItem = list.next(focusedItem);
        _this.setState({
          focusedItem: focusedItem
        });
        if (!multiple) {
          change(focusedItem);
        }
      } else if (key === 'ArrowUp' || key === 'ArrowLeft') {
        e.preventDefault();
        focusedItem = list.prev(focusedItem);
        _this.setState({
          focusedItem: focusedItem
        });
        if (!multiple) {
          change(focusedItem);
        }
      } else if (multiple && e.keyCode === 65 && e.ctrlKey) {
        e.preventDefault();
        _this.selectAll();
      }
    };
    //FIXME @widgetEditable
    _this._keyPress = function (e) {
      if (_this.props.disabled || _this.props.readOnly) {
        return;
      }
      widget_helpers_1.notify(_this.props.onKeyPress, [e]);
      if (e.defaultPrevented) {
        return;
      }
      if (!(_this.props.filter && _this.state.open)) {
        _this.search(String.fromCharCode(e.which), function (item) {
          if (_this._isMounted && _this.state.open) {
            _this.setState({
              focusedItem: item
            });
          } else {
            item && _this.change(item);
          }
        });
      }
    };
    _this.change = function (data) {
      widget_helpers_1.notify(_this.props.onChange, data);
      _this.updateSearchTerm('');
    };
    _this.updateSearchTerm = function (searchTerm) {
      var _a = _this.props,
        filter = _a.filter,
        value = _a.value,
        valueField = _a.valueField;
      var data = _this.props.data;
      var processed = filter ? _this.filter(data, searchTerm) : data;
      var idx = data_helpers_1.dataIndexOf(data, value, valueField);
      _this.setState({
        // filteredData: (open && filter) ? processed : undefined,
        filteredData: filter ? processed : undefined,
        focusedItem: processed[!~idx ? 0 : idx],
        searchTerm: searchTerm
      }, function () {
        widget_helpers_1.notify(_this.props.onSearch, _this.state.searchTerm);
      });
    };
    _this.focus = function (target) {
      var open = _this.state.open;
      var filter = _this.props.filter;
      var inst = target;
      if (open) {
        if (filter) {
          inst = _this._filter;
        }
      } else {
        inst = _this._input;
      }
      if (react_dom_1.default.findDOMNode(inst) && dom_helpers_1.activeElement() !== react_dom_1.default.findDOMNode(inst)) {
        react_dom_1.default.findDOMNode(inst).focus();
      }
    };
    _this.onOpening = function () {
      var disabled = _this.props.disabled;
      if (!disabled) {
        if (_this._list) {
          _this._list.forceUpdate();
        }
      }
    };
    _this.selectAll = function () {
      var valueField = _this.props.valueField;
      var values = _this.state.dataItems || [];
      var disabledItems = _this.props.disabledItems;
      //disabled values that are not selected
      var blacklist = disabledItems.filter(function (v) {
        return !interaction_1.contains(v, values, valueField);
      });
      var data = _this._data().filter(function (v) {
        return !interaction_1.contains(v, blacklist, valueField);
      });
      if (data.length === values.length) {
        data = disabledItems.filter(function (item) {
          return interaction_1.contains(item, values, valueField);
        });
        data = data.map(function (item) {
          return data_helpers_1.dataItem(_this._data(), item, valueField);
        });
      }
      widget_helpers_1.notify(_this.props.onChange, [data]);
    };
    _this._change = function (item, checked) {
      var multiple = _this.props.multiple;
      var values = _this.state.dataItems || [];
      multiple = !!multiple;
      _this.clearTimeout('focusedItem');
      _this.setState({
        focusedItem: item
      });
      if (!multiple) {
        return widget_helpers_1.notify(_this.props.onChange, checked ? item : null);
      }
      values = checked ? values.concat(item) : values.filter(function (v) {
        return v !== item;
      });
      widget_helpers_1.notify(_this.props.onChange, [values || []]);
    };
    _this._click = function (e) {
      var multiple = _this.props.multiple;
      if (_this.props.disabled || _this.props.readOnly) {
        return;
      }
      var wrapper = _this._filterWrapper;
      if (!_this.props.filter || !_this.state.open) {
        if (!multiple) {
          _this.toggle();
        } else {
          _this.open();
        }
      } else if (!multiple && !interaction_1.contains(react_dom_1.default.findDOMNode(wrapper), e.target)) {
        _this.close();
      }
    };
    _this.search = function (character, cb) {
      var word = ((_this._searchTerm || '') + character).toLowerCase();
      if (!character) {
        return;
      }
      _this._searchTerm = word;
      _this.setTimeout('search', function () {
        var list = _this._list;
        var key = _this.state.open ? 'focusedItem' : 'selectedItem';
        var item = list.next(_this.state[key], word);
        _this._searchTerm = '';
        if (item) {
          cb(item);
        }
      }, _this.props.delay);
    };
    _this.open = function () {
      if (!_this.state.open) {
        _this.setState({
          open: true,
          focused: true
        }, function () {
          // notify(this.props.onToggle, true); // TODO: Phase 2 callback
        });
      }
    };
    _this.close = function () {
      if (_this.state.open) {
        _this.setState({
          open: false
        }, function () {
          // notify(this.props.onToggle, false); // TODO: Phase 2 callback
        });
      }
    };
    _this.toggle = function () {
      if (_this.state.open) {
        _this.close();
      } else {
        _this.open();
      }
    };
    _this._data = function () {
      return _this.state.filteredData || (_this.props.data ? _this.props.data.concat() : []);
    };
    _this._values = function () {
      return _this.props.multiple ? _this.state.dataItems : _this.props.value;
    };
    _this.onItemSelect = function (item) {
      var isDisabled = interaction_1.isDisabledItem(item, _this.props);
      var isReadOnly = interaction_1.isReadOnlyItem(item, _this.props);
      if (isDisabled || isReadOnly) {
        return;
      }
      _this._change(item, !interaction_1.contains(item, _this._values(), _this.props.valueField));
    };
    _this._renderPlaceholderValue = function () {
      var _a;
      var _b = _this.props,
        valueField = _b.valueField,
        value = _b.value,
        ValueComponent = _b.valueComponent,
        placeholder = _b.placeholder,
        textField = _b.textField,
        multiple = _b.multiple,
        messages = _b.messages;
      var dataItems = _this.state.dataItems;
      var items = _this._data();
      var valueItem = data_helpers_1.dataItem(items, value, valueField); // take value from the raw data
      var inputPlaceholderClassNames = (_a = {}, _a[vdl_prefix_1.vdlPrefix('dropdown-list__input__placeholder')] = true, _a);
      if (!valueItem && placeholder) {
        return react_1.default.createElement("span", {
          className: classnames_1.classNames(inputPlaceholderClassNames)
        }, placeholder);
      } else if (_this.props.valueComponent) {
        return react_1.default.createElement(ValueComponent, {
          item: valueItem
        });
      }
      if (multiple) {
        if (dataItems && dataItems.length) {
          var selectedMsg = messages && messages.selected ? messages.selected : 'selected';
          return react_1.default.createElement("span", null, "(", dataItems.length, ") ", selectedMsg);
        } else {
          if (placeholder) {
            return placeholder;
          }
        }
      }
      return data_helpers_1.dataText(valueItem, textField);
    };
    _this._renderListBox = function () {
      var _a = _this.props,
        tabIndex = _a.tabIndex,
        busy = _a.busy,
        groupBy = _a.groupBy,
        role = _a.role,
        ListItem = _a.optionComponent;
      var List = _this.props.listComponent;
      var _b = _this.state,
        ariaActiveDescendant = _b.ariaActiveDescendant,
        focusedItem = _b.focusedItem;
      List = List || groupBy && list_groupable_1.ListGroupable || list_1.List;
      var elementProps = _1.omit(_this.props, Object.keys(ListBox.propTypes).concat(Object.keys(List.propTypes)));
      var listProps = _1.pick(_this.props, Object.keys(List.propTypes));
      var items = _this._data();
      var values = _this._values();
      return react_1.default.createElement("div", __assign({}, elementProps, {
        onKeyDown: _this._keyDown,
        onKeyPress: _this._keyPress,
        onBlur: _this.handleBlur,
        onFocus: _this.handleFocus,
        role: role,
        "aria-busy": !!busy,
        "aria-disabled": interaction_1.isDisabled(_this.props),
        "aria-readonly": interaction_1.isReadOnly(_this.props),
        "aria-activedescendant": ariaActiveDescendant,
        tabIndex: -1
      }), react_1.default.createElement(List, __assign({}, listProps, {
        ref: function ref(c) {
          _this._list = c;
        },
        tabIndex: tabIndex || '0',
        data: items,
        focused: focusedItem,
        onMove: _this._scrollTo,
        selected: values,
        onSelect: _this.onItemSelect,
        optionComponent: ListItem,
        onAriaActiveDescendant: _this.handleAriaActiveDescendant
      })));
    };
    var data = props.data,
      value = props.value,
      valueField = props.valueField,
      multiple = props.multiple,
      _a = props.defaultSearchTerm,
      defaultSearchTerm = _a === void 0 ? '' : _a;
    var open = _this.props.open !== undefined ? _this.props.open : false;
    _this.state = {
      dataItems: multiple && _1.splat(value).map(function (item) {
        return data_helpers_1.dataItem(data, item, valueField);
      }),
      open: open,
      searchTerm: defaultSearchTerm
    };
    return _this;
  }
  ListBox.prototype.componentDidMount = function () {
    this._isMounted = true;
    widget_helpers_1.validateList(this._list);
  };
  ListBox.prototype.componentWillReceiveProps = function (nextProps) {
    var multiple = nextProps.multiple,
      filter = nextProps.filter,
      value = nextProps.value,
      valueField = nextProps.valueField;
    var data = nextProps.data;
    var searchTerm = nextProps.searchTerm !== undefined ? nextProps.searchTerm : this.state.searchTerm || '';
    var open = nextProps.open !== undefined ? nextProps.open : this.state.open;
    var processed = filter ? this.filter(data, searchTerm) : data;
    var idx = data_helpers_1.dataIndexOf(data, value, 'grey');
    var newState = {
      // filteredData: (open && filter) ? processed : undefined,
      filteredData: filter ? processed : undefined,
      focusedItem: processed[!~idx ? 0 : idx],
      dataItems: multiple && _1.splat(value).map(function (item) {
        return data_helpers_1.dataItem(data, item, valueField);
      })
    };
    if (this.state.open !== open) {
      newState.open = open;
    }
    if (this.state.searchTerm !== searchTerm) {
      newState.searchTerm = searchTerm;
    }
    this.setState(newState);
  };
  ListBox.prototype.componentWillUnmount = function () {
    this._isMounted = false;
    this._timeoutManager.clearAllTimeouts();
  };
  ListBox.prototype.render = function () {
    var _a, _b, _c, _d;
    var _this = this;
    var _e = this.props,
      disabled = _e.disabled,
      busy = _e.busy,
      filter = _e.filter,
      dropdown = _e.dropdown,
      locale = _e.locale,
      readOnly = _e.readOnly;
    var messages = msgs(this.props.messages, locale);
    var _f = this.state,
      focused = _f.focused,
      open = _f.open;
    var popupProps = _1.omit(_1.pick(this.props, Object.keys(popup_1.Popup.propTypes)), ['className', 'style']);
    var listBoxClassNames = (_a = {}, _a[vdl_prefix_1.vdlPrefix('list-box')] = true, _a[vdl_prefix_1.vdlPrefix('list-box--dropdown')] = dropdown, _a[vdl_prefix_1.vdlPrefix('list-box--disabled')] = disabled, _a);
    var pickerClassNames = (_b = {}, _b[vdl_prefix_1.vdlPrefix('dropdown-list__picker')] = true, _b[vdl_prefix_1.vdlPrefix('dropdown-list__picker--readonly')] = readOnly, _b[vdl_prefix_1.vdlPrefix('dropdown-list__picker--busy')] = busy, _b);
    var inputContainerClassNames = (_c = {}, _c[vdl_prefix_1.vdlPrefix('dropdown-list__input-container')] = true, _c[vdl_prefix_1.vdlPrefix('dropdown-list__input-container--focus')] = focused, _c[vdl_prefix_1.vdlPrefix('dropdown-list__input-container--open')] = open, _c);
    var inputClassNames = (_d = {}, _d[vdl_prefix_1.vdlPrefix('dropdown-list__input')] = true, _d);
    return react_1.default.createElement("div", {
      className: classnames_1.classNames(listBoxClassNames)
    }, dropdown ? react_1.default.createElement("div", {
      ref: function ref(c) {
        _this._input = c;
      },
      onClick: this._click,
      onBlur: this.handleBlur
    }, react_1.default.createElement("div", {
      className: classnames_1.classNames(inputContainerClassNames)
    }, react_1.default.createElement("span", {
      className: classnames_1.classNames(pickerClassNames)
    }, react_1.default.createElement(angle_down_1.default, null), react_1.default.createElement("span", {
      className: vdl_prefix_1.vdlPrefix('aria-message')
    }, messages ? _1.result(messages.open, this.props) : 'Open')), react_1.default.createElement("div", {
      className: classnames_1.classNames(inputClassNames)
    }, this._renderPlaceholderValue())), react_1.default.createElement(popup_1.Popup, __assign({}, popupProps, {
      open: open,
      onOpen: function onOpen() {
        return _this.focus();
      },
      onOpening: function onOpening() {
        return _this.onOpening();
      }
    }), react_1.default.createElement("div", null, filter && this._renderFilter(messages), this._renderListBox()))) : react_1.default.createElement("div", null, filter && this._renderFilter(messages), this._renderListBox()));
  };
  ListBox.propTypes = {
    data: prop_types_1.default.array,
    value: prop_types_1.default.oneOfType([prop_types_1.default.any, prop_types_1.default.array]),
    onChange: prop_types_1.default.func,
    onMove: prop_types_1.default.func,
    onSearch: prop_types_1.default.func,
    onKeyPress: prop_types_1.default.func,
    onKeyDown: prop_types_1.default.func,
    multiple: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    dropdown: prop_types_1.default.bool,
    busy: prop_types_1.default.bool,
    valueComponent: custom_prop_types_1.default.elementType,
    optionComponent: custom_prop_types_1.default.elementType,
    itemComponent: custom_prop_types_1.default.elementType,
    listComponent: custom_prop_types_1.default.elementType,
    filter: custom_prop_types_1.default.filter,
    groupBy: custom_prop_types_1.default.accessor,
    textField: custom_prop_types_1.default.accessor,
    disabledItems: prop_types_1.default.array,
    readOnlyItems: prop_types_1.default.array,
    messages: prop_types_1.default.shape({
      open: prop_types_1.default.node,
      emptyList: prop_types_1.default.node,
      emptyFilter: prop_types_1.default.node,
      filterPlaceholder: prop_types_1.default.node
    }),
    delay: prop_types_1.default.number,
    minLength: prop_types_1.default.number,
    className: prop_types_1.default.string,
    tabIndex: prop_types_1.default.string,
    role: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    defaultSearchTerm: prop_types_1.default.string,
    searchTerm: prop_types_1.default.string,
    valueField: prop_types_1.default.string,
    locale: prop_types_1.default.string,
    children: prop_types_1.default.node
  };
  ListBox.defaultProps = {
    delay: 250,
    value: [],
    data: [],
    disabled: false,
    readOnly: false,
    optionComponent: list_box_option_1.ListBoxOption,
    role: 'listbox',
    multiple: false,
    groupBy: '',
    minLength: 1,
    searchTerm: '',
    dropdown: false
  };
  return ListBox;
}(react_1.default.Component);
exports.ListBox = ListBox;